import { createFileRoute } from '@tanstack/react-router';
import { ServiceRequestsPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/servicerequests/')({
  component: ServiceRequestsPage,
});
